/**
 * Adds button messages to the chat from the given event data.
 *
 * @param {Object} eventData - The data received from the server.
 * @param {string} type - The context type, e.g. "greetings".
 * @param {Function} setMessages - The setter for chat messages.
 * @param {Function} sendMessage - The function to handle message sending.
 */
export function addButtonToMessages(eventData, type, setMessages, sendMessage) {
    switch (type) {
      case "greetings":
      case "start_conversation":
        if (eventData.contracts) {
          setMessages((prevMessages) => [
            ...prevMessages,
            ...eventData.contracts.map((contract) => ({
              position: "left",
              type: "chat-button",
              text: `**${contract.contract_name}** per **${contract.plate_number}**`,
              onClick: () => sendMessage(`**${contract.contract_name}** per **${contract.plate_number}**`),
              timestamp: Date.now(),
            })),
          ]);
        }
        break;
      case "cross_selling":
      case "buy":
        if (eventData.options) {
          setMessages((prevMessages) => [
            ...prevMessages,
            ...eventData.options.map((option) => ({
              position: "left",
              type: "chat-button",
              text: `Attivazione **${option}**`,
              onClick: () => sendMessage(`Attivazione **${option}**`),
              timestamp: Date.now(),
            })),
          ]);
        }
        break;
      default:
        break;
    }
  }
  
export default {
  addButtonToMessages,
};